
// Vue
import {Options, Vue} from "vue-class-component";

// Components
import {
  ElRow,
  ElCol,
} from "element-plus";
import PlayerNavigationVue from "@/components/player/navigation.vue";
import AppPlayerTipsRootListIndexVue from "@/views/app/player/tips/root/list/index.vue";

@Options({
  components: {
    ElRow,
    ElCol,
    PlayerNavigationVue,
    AppPlayerTipsRootListIndexVue,
  },
})
export default class AppPlayerTipsRootIndexVue extends Vue {}
